import React from 'react';

import { Flex, Paragraph, Text } from '@rover/kibble/core';

import { ListItem } from '../types';

type Props = {
  items: ListItem[];
};

const FAQList = ({ items }: Props): JSX.Element => {
  return (
    <>
      {items.map((item, index) => (
        <Flex flexDirection="row" mt="4x" key={index}>
          {item.icon && (
            <Paragraph data-testid="faq-list-item-icon" mr="2x" aria-hidden>
              {item.icon}
            </Paragraph>
          )}
          <Paragraph>
            {item.label && <Text fontWeight="semibold">{item.label} </Text>}
            {item.text}
          </Paragraph>
        </Flex>
      ))}
    </>
  );
};

export default FAQList;
